// ###### DATA FETCH TRACKER
// Singleton service to track active data fetching operations (GET requests)
// Used to show sync status in the badge when background fetches are happening
// Follows the same pattern as syncService

class DataFetchTracker {
  constructor() {
    this.activeFetches = new Set(); // Set of endpoint strings currently fetching
    this.listeners = [];
  }

  // ##### REGISTER FETCH START
  startFetch(endpoint) {
    this.activeFetches.add(endpoint);
    this.notifyListeners();
  }

  // ##### REGISTER FETCH END
  endFetch(endpoint) {
    this.activeFetches.delete(endpoint);
    this.notifyListeners();
  }

  // ##### CHECK IF FETCHING
  isFetching() {
    return this.activeFetches.size > 0;
  }

  // ##### GET ACTIVE FETCH COUNT
  getActiveFetchCount() {
    return this.activeFetches.size;
  }

  // ##### ADD LISTENER
  // Returns unsubscribe function
  addListener(callback) {
    this.listeners.push(callback);
    
    // Immediately notify with current state
    callback({ isFetchingData: this.isFetching(), activeFetchCount: this.activeFetches.size });
    
    return () => {
      this.listeners = this.listeners.filter(l => l !== callback);
    };
  }

  // ##### NOTIFY LISTENERS
  notifyListeners() {
    const isFetching = this.isFetching();
    const activeFetchCount = this.activeFetches.size;
    this.listeners.forEach(callback => {
      callback({ isFetchingData: isFetching, activeFetchCount });
    });
  }
}

export const dataFetchTracker = new DataFetchTracker();
export default dataFetchTracker;
